import { render, staticRenderFns } from "./TPVGenerator.vue?vue&type=template&id=2784c906&"
import script from "./TPVGenerator.vue?vue&type=script&lang=js&"
export * from "./TPVGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports